/*  MUI  */
import { Download } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

/*  Shared  */
import CustomScript from 'application/Shared/Components/CustomScript/Containers/CustomScript';
import { FontSizes, URLs } from 'application/Shared/Constants';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';
import { MobileConfigDownload } from './Components/MobileConfigDownload';

const deploymentSteps = ({ onboarding, t }) => [
    {
        component: (
            <Typography variant="h4">
                {t('Integrations.setup_process')}
            </Typography>
        ),
        step: false
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step1')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step2')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <MobileConfigDownload stepText={t('Integrations.jamf.step3')} />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step4')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step5')
                }}
            />
        ),
        step: true
    },
    {
        note: (
            <Box>
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.jamf.note')
                    }}
                />
            </Box>
        ),
        step: false
    },
    {
        component: (
            <Typography variant="h4" style={{ marginTop: '16px' }}>
                {t('Integrations.jamf.section2')}
            </Typography>
        ),
        step: false
    },
    {
        component: (
            <Box display="flex" alignItems="center">
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.jamf.step6')
                    }}
                />
                <a
                    href={`${URLs.publicFiles}/Saaslio.pkg`}
                    data-trackid="partner_integrations_jamf_download_file"
                >
                    <Button
                        data-trackid="partner_integrations_jamf_download"
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: '8px' }}
                        size="small"
                    >
                        <Download
                            style={{
                                fontSize: FontSizes[2],
                                marginRight: '4px'
                            }}
                        />
                        {t('Integrations.Custom.makeMacMDM.step2.filename')}
                    </Button>
                </a>
            </Box>
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step7')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step8')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step9')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography variant="h4" style={{ marginTop: '16px' }}>
                {t('Integrations.jamf.section3')}
            </Typography>
        ),
        step: false
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step10')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step11')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step12')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Box width="100%">
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.jamf.step13')
                    }}
                />
                <CustomScript onboarding={onboarding} forJamf />
            </Box>
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.step15')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.bottomNote1')
                }}
            />
        ),
        step: false
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.jamf.bottomNote2')
                }}
            />
        ),
        step: false
    }
];

export const Jamf = ({ onboarding = false }) => {
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    return (
        <IntegrationWrapper
            hasToken
            deploymentSteps={deploymentSteps({ onboarding, t })}
            headerTitle={t('Integrations.jamf.title')}
            img={`/images/${userTheme}/integrations/jamf-color.png`}
            imgWidth="200px"
            onboarding={onboarding}
        />
    );
};
